import styled, { css } from 'styled-components';

export const cssTsukushi = css`
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: bold;
  font-style: normal;
`;

export const Tsukushi = styled.i`
  ${cssTsukushi}
`;
